import React from "react";
import { useAuth } from "../context/AuthContext";
import BorderTheme from "./BorderTheme";

const BorderLayout = ({ children }) => {
  const { user } = useAuth();
  const [borderTheme, setBorderTheme] = React.useState("default");

  // Load the user's selected border theme
  React.useEffect(() => {
    if (user?.selected_border_theme) {
      setBorderTheme(user.selected_border_theme);
    }
  }, [user]);

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      <BorderTheme theme={borderTheme} />
      {children}
    </div>
  );
};

export default BorderLayout;
